import { fromJS } from 'immutable';

import {
  CHANGE_CREDENTIAL_CATEGORY,
  CHANGE_CREDENTIAL_FILTER,
  CHANGE_CREDENTIAL_SIDEBAR,
  CHANGE_CREDENTIAL_FILTERS,
  LOAD_PROJECTS_NAME_SUCCESS,
  LOAD_CREDENTIALS_SUCCESS,
  TOGGLE_CREDENTIAL_FORM,
  TOGGLE_CREDENTIAL_GROUP_VIEW,
  TOGGLE_CREDENTIAL_VIEW,
  CHANGE_STATUS_BAR_SEARCH,
  UPDATE_CREDENTIAL_SUCCESS,
  LOAD_MODERATED_CREDENTIALS_SUCCESS,
  SET_AUTH_USER,
  TOGGLE_MODERATE_FORM,
  SET_MODERATED_COUNT,
} from 'constants/ActionTypes';
import { normalizeEntities } from '../../helpers/utilHelpers';
import { CREDENTIAL_LIST } from 'constants/SettingConstants';

const initialState = fromJS({
  sidebarCollapsed: false,
  dataset: [],
  filters: {
    filter: 'all',
    category: 'all',
    projectId: null,
  },
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
  view: {
    credentialId: null,
    isVisible: false,
  },
  form: {
    isVisible: false,
    credentialId: null,
    projectNames: [],
  },
  moderateForm: {
    isVisible: false,
    credentialId: null,
  },
  moderatedCount: null,
});

const credentialListReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_CREDENTIAL_SIDEBAR:
      return state.setIn(['sidebarCollapsed'], action.collapsed);
    case TOGGLE_CREDENTIAL_VIEW:
      if (state.getIn(['view', 'isVisible'])) {
        return state.merge(
          fromJS({
            view: {
              isVisible: false,
              credentialId: null,
            },
          }),
        );
      } else {
        return state.merge(
          fromJS({
            view: {
              isVisible: true,
              credentialId: action.credentialId,
            },
          }),
        );
      }
    case LOAD_PROJECTS_NAME_SUCCESS:
      return state.setIn(['form', 'projectNames'], normalizeEntities(action.projects.items, 'projectId'));
    case TOGGLE_CREDENTIAL_FORM:
      if (state.getIn(['form', 'isVisible'])) {
        return state.merge(
          fromJS({
            form: {
              isVisible: false,
              credentialId: null,
            },
          }),
        );
      } else {
        return state.merge(
          fromJS({
            form: {
              isVisible: true,
              credentialId: action.credentialId,
            },
          }),
        );
      }
    case LOAD_CREDENTIALS_SUCCESS:
      return state.merge(
        fromJS({
          dataset: action.credentials.items.map((item) => item.accessId),
          pagination: {
            totalCount: action.credentials._meta.totalCount,
            pageCount: action.credentials._meta.pageCount,
            currentPage: action.credentials._meta.currentPage,
            perPage: action.credentials._meta.perPage,
          },
        }),
      );
    case LOAD_MODERATED_CREDENTIALS_SUCCESS:
      return state.set('moderatedCount', action.credentials.items.length);
    case SET_MODERATED_COUNT:
      if (action.count === 'add') {
        return state.set('moderatedCount', state.get('moderatedCount') + 1);
      } else {
        return state.set('moderatedCount', state.get('moderatedCount') - 1);
      }

    case UPDATE_CREDENTIAL_SUCCESS:
      if (action.credential.status !== 'moderated' && !state.get('dataset')?.includes(action.credential.accessId)) {
        return state.set('dataset', state.get('dataset').unshift(action.credential.accessId));
      } else {
        return state;
      }
    case CHANGE_CREDENTIAL_CATEGORY:
      return state.setIn(['filters', 'category'], action.category);
    case CHANGE_STATUS_BAR_SEARCH:
      return state.merge(
        fromJS({
          filters: {
            filter: null,
            category: null,
            projectId: null,
          },
        }),
      );
    case CHANGE_CREDENTIAL_FILTER:
      if (action.filter === 'all') {
        return state.merge(
          fromJS({
            filters: {
              category: 'all',
              filter: action.filter,
              projectId: state.getIn(['filters', 'projectId']),
            },
          }),
        );
      }
      return state.setIn(['filters', 'filter'], action.filter);
    case TOGGLE_CREDENTIAL_GROUP_VIEW:
      return state.setIn(['filters', 'category'], null);
    case SET_AUTH_USER:
      if (action.user.state && action.user.state[CREDENTIAL_LIST] && action.user.state[CREDENTIAL_LIST].filters) {
        return state.set('filters', fromJS(action.user.state[CREDENTIAL_LIST].filters));
      }
      return state;
    case TOGGLE_MODERATE_FORM:
      return state.merge(
        fromJS({
          moderateForm: {
            isVisible: action.credentialId ? true : false,
            credentialId: action.credentialId,
          },
        }),
      );
    case CHANGE_CREDENTIAL_FILTERS:
      return state.set('filters', fromJS(action.values));
    default:
      return state;
  }
};

export default credentialListReducer;
